import React, { useEffect, useRef } from 'react';
import useApi from '../hooks/useApi';
import { useNavigate } from 'react-router-dom';

export default function PayPalButtonComponent({ user_id, onSuccess, onError, onProcessingChange }) {
  const { request } = useApi();
  const navigate = useNavigate();
  const orderRef = useRef(null); 

  useEffect(() => {
    if (window.paypal) {
            if (document.getElementById('paypal-button-container').children.length === 0) {
                    window.paypal.Buttons({
                        createOrder: async function () {
                        const res = await request({
                            method: 'post',
                            url: `/api/v1/users/order/`,
                            data: {
                            user_id,
                            payment_gateway: 'paypal',
                            payment_type: 'subscription',
                            amount: 5,
                            currency: 'USD'
                            }
                        });
                        const order_id = res?.data?.order_id;
                        if (!order_id) throw new Error('Order ID not received');
                        orderRef.current = order_id; 
                        return order_id;
                        },
                        onApprove: async function (data) {
                        onProcessingChange?.(true);
                        try {
                            const res = await request({
                            method: 'post',
                            url: `/api/v1/users/paypal_order/`,
                            data: {
                                order_id: orderRef.current, 
                                user_id
                            }
                            });
                            setTimeout(() => onSuccess?.(), 50);
                        } catch (err) {
                            console.error('Verification failed:', err);
                            onError?.(err);
                        }
                        },
                        onError: (err) => {
                        console.error('PayPal error:', err);
                        onError?.(err);
                        },
                        onCancel: () => onProcessingChange?.(false),
            }).render("#paypal-button-container");
        }
    }
  }, []);

  return <div id="paypal-button-container" className="mt-4"></div>;
}
